import Box from "@mui/material/Box";
import Skeleton from "../../../../CommonComponents/Skeleton";

const StudentsRemarksSkeleton = () => {
  return (
    <Box sx={{width:'100%',bgcolor: "white",display:"flex",flexDirection:"column",padding:"16px 24px",borderRadius:"8px"}}>
        <Skeleton animation="wave" sx={{width:"100%",height:"50px"}}/>
        <Skeleton sx={{height:"40px",width:"176px",marginTop:"10px"}} animation="wave" />
        <Box
            sx={{display:"flex",height:"40px",justifyContent:"space-between",marginTop:"12px",width:"100%"}}
        >
            {Array.from({ length: 2 }).map((_, i) => (
                <Skeleton key={i} sx={{height:"30px",width:"174.5px"}} animation="wave" />
            ))}
        </Box>
    </Box>
  )
}

export default StudentsRemarksSkeleton